import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Services from './pages/Services';
import Girls from './pages/Girls';
import Availabilities from './pages/Availabilities';
import Styling from './pages/Styling';
import { useEffect, useState } from 'react';
import { getAllData } from './firebase/services';
import { AuthProvider } from './context/AuthContext';

function AdminApp() {
    const [ladies, setLadies] = useState([]);
    const [services, setServices] = useState([]);
    const [avails, setAvails] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                await getAllData(setAvails, setLadies, setServices);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    return (
        <AuthProvider>
            <Routes>
                <Route path="/" element={<Navigate to="/admin/login" replace />} />
                <Route path="/login" element={<Login />} />

                <Route path="/*" element={
                    <ProtectedRoute>
                        <div className="min-h-screen bg-gray-800 flex">
                            <Sidebar />
                            <div className="flex-1 ml-64 p-8">
                                <Routes>
                                    <Route
                                        path="/services"
                                        element={<Services services={services} setServices={setServices} />}
                                    />
                                    <Route
                                        path="/girls"
                                        element={<Girls ladies={ladies} setLadies={setLadies} />}
                                    />
                                    <Route
                                        path="/availabilities"
                                        element={
                                            <Availabilities
                                                availabilities={avails}
                                                setAvailabilities={setAvails}
                                                ladies={ladies}
                                            />
                                        }
                                    />
                                    <Route
                                        path="/styling"
                                        element={<Styling />}
                                    />
                                </Routes>
                            </div>
                        </div>
                    </ProtectedRoute>
                } />
            </Routes>
        </AuthProvider>
    );
}

export default AdminApp;